export enum SnapshotDataTypeEnum {
  PC = 'PUT/CALL',
  RF = 'RR/FLY',
}
